import * as React from "react";
import {
    createStyles,
    Theme,
    Modal,
    Paper,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import LoaderButton from "../shared/LoaderButton";

type UpdateUserStatusDialogConfirmationProps = WithStyles<typeof styles> & {
    visible: boolean;
    updateUserStatus: () => void;
    closeDialog: () => void;
    updateUserStatusEmail: string;
    updateUserStatusEnable: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        body: {
            [theme.breakpoints.down("xs")]: { padding: theme.spacing(2) },
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: theme.spacing(4),
            textAlign: "center"
        },
        buttonWrapper: {
            [theme.breakpoints.down("xs")]: {
                marginBottom: theme.spacing(1.5)
            },
            marginBottom: theme.spacing(3)
        },
        bodyText: {
            [theme.breakpoints.down("xs")]: { fontSize: 12 },
            color: theme.palette.text.secondary,
            lineHeight: 1.5,
            marginBottom: theme.spacing(3),
            textAlign: "center"
        },
        firstButton: {
            marginRight: theme.spacing(2)
        },
        header: {
            borderBottom: `8px solid ${theme.palette.primary.main}`,
            padding: theme.spacing(2),
            textAlign: "center",
            width: "100%"
        },
        headerText: {
            [theme.breakpoints.down("xs")]: { fontSize: 20 },
            color: theme.palette.primary.main,
            fontWeight: "bold",
            margin: "0 auto"
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            margin: theme.spacing(2),
            maxWidth: 600,
            outline: "none",
            width: "100%"
        }
    });

function UpdateUserStatusConfirmationDialog({
    classes,
    closeDialog,
    updateUserStatus,
    updateUserStatusEmail,
    updateUserStatusEnable,
    visible
}: UpdateUserStatusDialogConfirmationProps) {
    return (
        <Modal open={visible} className={classes.body}>
            <Paper className={classes.paper} elevation={2}>
                <div className={classes.header}>
                    <Typography
                        component="h1"
                        variant="h5"
                        className={classes.headerText}
                    >
                        {`Confirm ${
                            updateUserStatusEnable ? "Enable" : "Disable"
                        }`}
                    </Typography>
                </div>
                <div className={classes.body}>
                    <Typography
                        component="div"
                        variant="h6"
                        className={classes.bodyText}
                    >
                        <div>
                            Are you sure you want to{" "}
                            {updateUserStatusEnable ? "enable" : "disable"} this
                            bidder account?
                        </div>
                        <div>{updateUserStatusEmail}</div>
                    </Typography>

                    <div className={classes.buttonWrapper}>
                        <LoaderButton
                            className={classes.firstButton}
                            color="primary"
                            type="button"
                            variant="contained"
                            onClick={updateUserStatus}
                            loading={false}
                        >
                            Confirm
                        </LoaderButton>
                        <LoaderButton
                            onClick={closeDialog}
                            color="secondary"
                            type="button"
                            variant="contained"
                            loading={false}
                        >
                            Cancel
                        </LoaderButton>
                    </div>
                </div>
            </Paper>
        </Modal>
    );
}

export default withStyles(styles)(UpdateUserStatusConfirmationDialog);
